module.exports = __webpack_public_path__ + "img/3.2b56fea8.jpg";